import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import contractVersionsPayrollPolicies, {
  ContractVersionsPayrollPoliciesProvider,
} from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import PageLoading from 'modules/layout/components/Page/Loading'
import PayrollBundle from 'modules/payroll_bundle/components/PayrollBundle'
import { PayrollResultsContextProvider } from 'modules/payroll_bundle/lib/PayrollResultContext'
import { BulkImportSupplementsContextProvider } from 'modules/payroll_bundle/lib/bulkImportSupplementsContext'
import { FrequencyContextProvider } from 'modules/payroll_bundle/lib/frequencyContext'
import { PayrollPaymentsContextProvider } from 'modules/payroll_bundle/lib/payrollPaymentsContext'
import { PolicyPageContextProvider } from 'modules/payroll_bundle/lib/policyPageContext'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import { SepaContextProvider } from 'modules/payroll_bundle/lib/sepaContext'

// Runs for all /payroll-management/policies/:id routes.
const PolicyPage = () => {
  const {
    currentPolicyPeriods,
    periodIndex,
    setPeriodId,
    loadingPolicyPeriodCollection,
    setCurrentPolicy,
    policyId: currentPolicyId,
  } = usePolicyPeriods()
  const { policyId: policyIdRoute, periodId: periodIdRoute } = useParams()
  const [isInitialized, setIsInitialized] = useState(false)
  const policyPeriod = currentPolicyPeriods[periodIndex]

  const navigate = useNavigate()
  const { navigation } = useNavigation()

  useUnsafeEffect(() => {
    if (!loadingPolicyPeriodCollection && !isInitialized) {
      setIsInitialized(true)
      setCurrentPolicy(policyIdRoute ?? '', periodIdRoute)
    } else if (isInitialized && !currentPolicyId) {
      navigate(navigation.payrollBundle.fullPath())
    }
  }, [
    isInitialized,
    loadingPolicyPeriodCollection,
    navigate,
    navigation,
    periodIdRoute,
    policyIdRoute,
    currentPolicyId,
    setCurrentPolicy,
    setPeriodId,
  ])

  if (!policyIdRoute) throw new Error('Policy ID missing in route')

  if (currentPolicyId != policyIdRoute) {
    return (
      <Box flexGrow height="full" justifyContent="center">
        <PageLoading />
      </Box>
    )
  }

  const status = policyPeriod?.attributes.status

  return (
    <PayrollResultsContextProvider>
      <PayrollPaymentsContextProvider>
        <SepaContextProvider>
          <FrequencyContextProvider>
            <BulkImportSupplementsContextProvider>
              <ContractVersionsPayrollPoliciesProvider collection={contractVersionsPayrollPolicies}>
                <PolicyPageContextProvider policyPeriod={policyPeriod}>
                  <PayrollBundle status={status} />
                </PolicyPageContextProvider>
              </ContractVersionsPayrollPoliciesProvider>
            </BulkImportSupplementsContextProvider>
          </FrequencyContextProvider>
        </SepaContextProvider>
      </PayrollPaymentsContextProvider>
    </PayrollResultsContextProvider>
  )
}

export default observer(PolicyPage)
